module.exports = __webpack_public_path__ + "static/media/sidebar-4.9994f0cb.jpg";